import { ConsentComponent } from '../components/consent/consent.component';
import { CounterComponent } from '../components/counter/counter.component';
import { LikesComponent } from '../components/likes/likes.component';
import { ProgressRingComponent } from '../components/progress-ring/progress-ring.component';
import { SettingsComponent } from '../components/settings/settings.component';
import { ConsentModule } from '../consent.module';
import { ControlsModule } from '../controls.module';
import { ConvertModule } from '../convert.module';
import { DownloadModule } from '../download.module';
import { DragModule } from '../drag.module';
import { FinishOverlayModule } from '../finish-overlay.module';
import { Application } from '../framework/application';
import { ProgressModule } from '../progress.module';
import { ZipperModule } from '../zipper.module';

export class IndexApplication extends Application {
  constructor() {
    super('index', {
      declarations: [
        SettingsComponent,
        ProgressRingComponent,
        ConsentComponent,
        CounterComponent,
        LikesComponent,
      ],
      modules: [
        ConsentModule,
        ControlsModule,
        DragModule,
        DownloadModule,
        ZipperModule,
        ProgressModule,
        FinishOverlayModule,
        ConvertModule,
      ],
      tracesSampler: (ctx) => {
        if (ctx?.transactionContext?.op === 'convert') {
          return 1;
        }

        return 0.1;
      },
    });
  }

  protected async onInit() {}
}
